module.exports = __webpack_public_path__ + "static/img/coupon-box-btn-nike.acd629f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/Play/img/result/coupon-box-btn-nike.png
// module id = 184
// module chunks = 0